
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host {
--outline-alert--default-info-background:var(--outline-white);

--outline-alert--default-info-text:var(--status-info);

--outline-alert--default-info-border:var(--status-info);

--outline-alert--default-success-background:var(--outline-white);

--outline-alert--default-success-text:var(--status-success);

--outline-alert--default-success-border:var(--status-success);

--outline-alert--default-warning-background:var(--outline-white);

--outline-alert--default-warning-text:var(--status-warning);

--outline-alert--default-warning-border:var(--status-warning);

--outline-alert--default-error-background:var(--outline-white);

--outline-alert--default-error-text:var(--status-error);

--outline-alert--default-error-border:var(--status-error);
`;